<template>
  <div :class="flag ? 'public-content' : 'public-content bgcs'">
    <div v-if="flag">
      <div class="public_form_item">
        <div class="flex flex_ailgn">
          <h3 class="title">银行流水</h3>
        </div>
      </div>
      <div class="form-item-public" style="margin-top: 10px;">
        <el-row>
          <el-col :span="20">
            <el-form inline label-position="left">
              <el-form-item label="银行账户">
                <el-select
                  size="mini"
                  v-model="bank"
                  placeholder="请选择"
                  @change="slectbanknumber"
                  value-key="bankCardNo"
                >
                  <el-option
                    v-for="(item,index) in banklist"
                    :key="index"
                    :label="'尾号'+item.bankCardNo.substr(-4,4)+'（'+item.bankNo+'）'"
                    :value="item"
                  ></el-option>
                  <el-option label="添加账户" value="add"></el-option>
                  <el-option
                    v-for="(item,index) in dictList.otheroBtn"
                    :key="index"
                    v-if="item.permission == 'ac:bank:breakContract'"
                    :label="item.label"
                    value="resci"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="起止日期">
                <el-date-picker
                  :clearable="false"
                  size="mini"
                  v-model="dates"
                  type="daterange"
                  range-separator="至"
                  :picker-options="expireTimeOption"
                  @change="changedate"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="币种">
                <el-select
                  size="mini"
                  v-model="currType"
                  placeholder="请选择"
                  @change="moneyTypechange"
                  value-key="label"
                >
                  <el-option
                    v-for="(item,index) in moneyType"
                    :key="index"
                    :label="item.label"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" class="minButton" @click="init()">查询</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="4" style="display: flex;justify-content: flex-end;">
            <div>
              <!-- <el-button size="mini" @click="exportwater('d','导出流水明细')">导出交易流水</el-button> -->
              <el-button
                v-for="(item,index) in dictList.otheroBtn"
                :key="index"
                v-if="item.permission == 'ac:bank:exportStatement'"
                size="mini"
                @click="exportwater('d','导出流水明细')"
              >{{item.label}}</el-button>

              <el-dropdown
                trigger="click"
                @command="handleCommand"
                v-if="dictList.downList.length >0"
              >
                <el-button size="mini">
                  电子回单
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="item.permission"
                    v-for="(item,index) in dictList.downList"
                    :key="index"
                  >{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="table-item-public">
        <el-table
          border
          size="small"
          style="width: 100%"
          :data="tableData"
          v-loading="loading"
          @select="selectRows"
          @select-all="selectRows"
          ref="waterRefs"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="交易流水号" prop="serialNo" width="auto" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="checkdetail(scope.row)">{{scope.row.serialNo}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="交易时间" prop="transTime" width="auto" align="center">
            <template slot-scope="scope">
              <span>{{$util.formatDate.format(scope.row.transTime,'yyyy-MM-dd hh:mm:ss')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易金额" prop="amount" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.amount}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column label="对方银行" prop="recipbkName" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.recipbkName}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column label="对方账号" prop="recipAcc" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.recipAcc}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column label="对方账户名" prop="recipName" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.recipName}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column label="用途" prop="purpose" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.purpose}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column label="摘要" prop="summary" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.summary}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column label="当前余额" prop="balance" width="auto" align="center">
            <!-- <template slot-scope="scope">
              <el-button type="text"  @click="checkdetail(scope.row)">{{scope.row.balance}}</el-button>
            </template>-->
          </el-table-column>
          <el-table-column
            label="电子回单"
            prop="receiptState"
            width="auto"
            align="center"
            v-if="dictList.downList.length >0"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.receiptState==0||scope.row.receiptState==1||scope.row.receiptState==2"
              >{{typeinfo(scope.row.receiptState)}}</span>
              <el-button type="text" v-else @click="seePDFfile(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 全局默认分页样式 -->
      <div
        class="public_page_item"
        style="margin-top: 20px;display: flex;justify-content: flex-end;"
      >
        <el-pagination
          background
          small
          @size-change="pageSizeChange"
          @current-change="pageIndexChange"
          @prev-click="pageIndexChange"
          @next-click="pageIndexChange"
          layout="total, prev, pager, next, sizes, jumper"
          :total="page.totall"
          :current-page="page.currentPage"
          :page-size="page.maxResult"
        ></el-pagination>
      </div>
    </div>

    <!-- 没有流水的 -->
    <div class="nohasWater" v-if="!flag">
      <div
        class="btn_bannks tips gray"
        type="primary"
        v-if="ifBankWarter"
        @click="gobackBankList"
      >返回到银行流水</div>
      <!-- <div class="nohasWater"> -->
      <!-- <el-carousel>
        <el-carousel-item v-for="(item,index) in four" :key="index">
          <h3>{{ item }}</h3>
        </el-carousel-item>
      </el-carousel>-->
      <div class="banner_bank">
        <div class="banner_bank_container">
          <img src="/static/img/title.png" alt />
          <span class="text_s">线上一键查询，自助式无限次打印银行流水数据，为您带来更便捷，安全，多样的财务管理体验</span>
        </div>
        <div class="btn_position">
          <div
            class="btn_bannks tips"
            v-for="(item,index) in dictList.otheroBtn"
            :key="index"
            v-if="item.permission == 'ac:bank:openAccount'"
            type="primary"
            @click="onlinesign"
          >{{item.label}}</div>
          <div
            class="btn_bannks"
            v-for="(item,index) in dictList.otheroBtn"
            :key="index"
            v-if="item.permission == 'ac:bank:contract'"
            type="primary"
            plain
            @click="navigatorforIE"
          >{{item.label}}</div>
        </div>
        <!-- <div class="btn_position bot">
          <div class="btn_bannks tips gray" type="primary" v-if="tableData.length > 0" @click="gobackBankList">返回到银行流水</div>
        </div>-->
      </div>
      <div class="banner_footer">
        <div class="banner_footer_left">
          <img src="/static/img/bottom_d.png" alt class="load" />
          <img src="/static/img/people.png" alt class="people" />
          <div class="buttonGroup">
            <!-- <span @click="handleClickBtn('1')">查看如何预约开户</span> -->
            <span @click="handleClickBtn('2')">查看如何线上签约</span>
          </div>
        </div>
        <div class="banner_footer_right"></div>
      </div>
      <!-- <div style="width: 100%;display: flex;justify-content: center;">
        <div class="wrap">
          <div class="left com">
            <div class="content">
              未开通企业银行的点这里
              这里可以有一段文字描述
            </div>
            <el-button v-for="(item,index) in dictList.otheroBtn" :key="index" v-if="item.permission == 'ac:bank:openAccount'" type="primary" @click="onlinesign">预约开户</el-button>

          </div>
          <div class="right com">
            <div class="content">
              已开通企业银行的点这里
              也可以有一段文字描述
            </div>
            <el-button v-for="(item,index) in dictList.otheroBtn" :key="index" v-if="item.permission == 'ac:bank:contract'" type="primary" plain @click="signup">线上签约</el-button>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content:center;">
        <el-button type="primary" v-if="tableData.length > 0" @click="gobackBankList">返回到银行流水</el-button>
      </div>-->
    </div>

    <!-- 签约 -->
    <signing :visible="sing" @refresh="refresh" @showpage="showpage"></signing>
    <!-- 预约开户 -->
    <openaccount :visible="account" @refresh="refreshAcc"></openaccount>
    <!-- 流水明细 -->
    <waterdetail :visible="detail" @refresh="refreshdetail"></waterdetail>
    <!-- 导出明细 -->
    <exportdetail :visible="exportss" @refresh="refreshexport" @clearSelect="clearSelect"></exportdetail>
    <!-- 解约 -->
    <arefire :visible="fire" @refresh="refreshfire" @ref2="refsss"></arefire>
    <!-- 查看PDF -->
    <showpdf :visible="showpdf" @refresh="refreshpdf" :superDataURL="superDataURL"></showpdf>
  </div>
</template>

<script>
import signing from "@/components/bankwater/Signing";
import openaccount from "@/components/bankwater/openAccount.vue";
import waterdetail from "@/components/bankwater/waterDetail.vue";
import exportdetail from "@/components/bankwater/exportdetail.vue";
import arefire from "@/components/bankwater/arefire";
import showpdf from "@/components/bankwater/showpdf";
export default {
  components: {
    signing,
    openaccount,
    waterdetail,
    exportdetail,
    arefire,
    showpdf
  },
  data() {
    return {
      superDataURL: "", // 打开本地pdf
      loading: false,
      ifBankWarter: false,
      banklist: [],
      moneyType: [],
      dates: "",
      bank: "",
      startMonth: "",
      currType: "",
      page: {
        currentPage: 1,
        maxResult: 10,
        totall: 0,
        startTime: "",
        endTime: "",
        bankNo: "",
        currType: ""
      },
      showpdf: {
        showdialog: false,
        row: ""
      },
      fire: {
        showdialog: false
      },
      sing: {
        showdialog: false
      },
      account: {
        showdialog: false
      },
      detail: {
        showdialog: false,
        row: "",
        moneyTypeList: ""
      },
      exportss: {
        showdialog: false,
        tit: "",
        type: "",
        selrows: [],
        bankNo: "",
        signDate: ""
      },
      expireTimeOption: {},
      flag: false,
      tableData: [],
      four: [1, 2, 3, 4],

      dictList: {
        downList: [],
        otheroBtn: []
      }
    };
  },
  created() {
    this.getAllPremissionMenu();
  },
  activated() {
    let date = new Date();
    var month11 = date.getMonth() + 2;

    let month = parseInt(date.getMonth()) + 1;
    let firstone = date.getFullYear() + "-" + month + "-01";
    let currentTime = date.toLocaleDateString().replace(/\//g, "-");
    this.dates = [firstone, currentTime];
    this.pagejugment(); // 判断是银行流水还是签约
  },
  computed: {
    typeinfo: function() {
      return function(item) {
        let textInfo = "";
        if (item == "0") {
          textInfo = "未生成";
        } else if (item == "1") {
          textInfo = "生成中";
        } else if (item == "2") {
          textInfo = "生成失败";
        } else {
          textInfo = "查看";
        }
        return textInfo;
      };
    }
  },
  methods: {
    // 点击查看演示pdf
    handleClickBtn(index) {
      if (index === "1") {
        this.superDataURL = "/static/pdf/kaihuStep.pdf";
      } else {
        this.superDataURL = "/static/pdf/qianyueStep.pdf";
      }
      this.showpdf.showdialog = true;
    },
    seePDFfile(row) {
      this.showpdf.showdialog = true;
      this.showpdf.row = row;
    },
    refreshpdf(parm) {
      this.showpdf.showdialog = parm;
      this.sing.showdialog = false;
      this.superDataURL = "";
    },
    clearSelect() {
      this.$refs.waterRefs.clearSelection();
      this.exportss.showdialog = false;
      this.exportss.selrows.splice(0);
    },
    moneyTypechange(val) {
      this.page.currType = val.value;
    },
    slectbanknumber(val) {
      this.exportss.bankNo = val.bankCardNo;
      this.page.bankNo = val.bankCardNo;
      let str = val.creatData + "-1";
      let aa = new Date(str);
      this.exportss.signDate = val.creatData;
      this.expireTimeOption = {
        disabledDate(date) {
          var Tdate = new Date();
          return (
            date.getTime() < new Date(aa).getTime() ||
            new Date(Tdate.getFullYear(), Tdate.getMonth() + 1, 0).getTime() <=
              new Date(date.getFullYear(), date.getMonth(), 0).getTime()
          );
        }
      };
      if (val == "add" || val == "resci") {
        let parm = JSON.parse(sessionStorage.getItem("lastname"));
        this.bank = "";
        if (val == "add") {
          this.flag = false;
        } else {
          this.fire.showdialog = true;
        }
      } else {
        sessionStorage.setItem("lastname", JSON.stringify(val));
      }
    },
    selectRows(rows) {
      this.exportss.selrows = rows;
    },
    refreshfire(parm) {
      this.$set(this.fire, "showdialog", parm);
      this.gobackBankList();
      this.init();
      this.pagejugment(); // 判断是银行流水还是签约
    },
    refsss(parm) {
      if (parm == "shouye") {
        this.flag = false;
      } else {
        this.flag = true;
      }
      this.bankNumbers();
    },
    handleCommand(item) {
      if (item == "ac:bank:getReceipt") {
        this.exportwater("a", "生成电子回单");
      } else if (item == "ac:bank:downReceiptPDF") {
        this.exportwater("b", "下载电子回单");
      } else if (item == "ac:bank:printReceiptPDF") {
        this.exportwater("c", "打印电子回单");
      }
    },
    exportwater(type, str) {
      //导出流水明细
      this.exportss.showdialog = true;
      this.exportss.tit = str;
      this.exportss.type = type;
    },
    refreshexport(parm) {
      //导出流水明细
      this.$set(this.exportss, "showdialog", parm);
    },
    //签约成功
    showpage(parm) {
      this.flag = parm;
      this.init();
      this.bankNumbers();
    },
    navigatorforIE() {
      const _ = this;
      // var userAgent = navigator.userAgent;
      // var isLessIE11 =
      //   userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
      // var isEdge = userAgent.indexOf("Edge") > -1 && !isLessIE11;
      // var isIE11 =
      //   userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      // if (isLessIE11) {
      //   var IEReg = new RegExp("MSIE (\\d+\\.\\d+);");
      //   // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
      //   IEReg.test(userAgent);
      //   // 取正则表达式中第一个小括号里匹配到的值
      //   var IEVersionNum = parseFloat(RegExp["$1"]);
      //   if (IEVersionNum >= 9) {
      //     _.sing.showdialog = true;
      //   } else {
      //     _.$message.error(
      //       "请使用9.0以上IE浏览器或者360浏览器兼容模式进行线上签约!"
      //     );
      //     //_.signup();
      //   }
      // } else if (isEdge) {
      //   _.sing.showdialog = true;
      // } else if (isIE11) {
      //   _.sing.showdialog = true;
      // } else {
      //   //其他浏览器！
      //   _.$message.error(
      //     "请使用9.0以上IE浏览器或者360浏览器兼容模式进行线上签约!"
      //   );
      //   //_.signup();
      // }
       _.sing.showdialog = true;
    },
    signup() {
      //签约
      const _ = this;
      _.$confirm(
        "请使用9.0以上IE浏览器或者360浏览器兼容模式进行线上签约!",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(res => {
        this.sing.showdialog = true;
      });
    },
    refresh(parm) {
      //签约
      this.$set(this.sing, "showdialog", parm);
    },
    onlinesign() {
      //预约开户
      this.account.showdialog = true;
    },
    refreshAcc(parm) {
      //预约开户
      this.$set(this.account, "showdialog", parm);
    },
    checkdetail(row) {
      //交易流水明细
      this.detail.showdialog = true;
      this.detail.row = row;
    },
    refreshdetail(parm) {
      //交易流水明细
      this.$set(this.detail, "showdialog", parm);
    },

    changedate(val) {
      this.page.startTime = val[0];
      this.page.endTime = val[1];
    },
    pagejugment() {
      // this.$http.post("/bankContract/queryCobtractByCid", {}).then(res => {
      //   if (res && res.data.code == "1") {
      //     this.flag = res.data.data;
      //     this.ifBankWarter = res.data.data;
      //     if (this.flag) {
      //       // this.fingalltypes();
      //       this.bankNumbers();
      //       // this.init();
      //     }
      //   }
      // });
    },
    bankNumbers() {
      this.$http.post("/bankContract/getAllBankNo", {}).then(res => {
        if (res && res.data.code == "1") {
          this.banklist = res.data.data;
          let ss = res.data.data;
          if (ss && ss.length > 0) {
            this.bank = ss[0];
            let str = ss[0].creatData;
            // let aa=new Date(str)
            this.exportss.signDate = str;
            this.$set(this.page, "bankNo", this.bank.bankCardNo);
            this.slectbanknumber(ss[0]);
          } else {
            this.bank = "";
            this.$set(this.page, "bankNo", "");
          }
          this.fingalltypes();
        }
      });
    },
    fingalltypes() {
      this.$http.post("/sys/dict/list", { type: "currtype" }).then(res => {
        if (res && res.data.code == "1") {
          this.moneyType = res.data.data;
          this.detail.moneyTypeList = res.data.data;
          if (res.data.data && res.data.data.length > 0) {
            this.currType = res.data.data[0];
            this.$set(this.page, "currType", this.currType.value);
          } else {
            this.currType = "";
            this.$set(this.page, "currType", "");
          }
          this.init();
        }
      });
    },
    init(pages, size) {
      this.$set(
        this.page,
        "currentPage",
        pages ? pages : this.page.currentPage
      );
      this.$set(this.page, "maxResult", size ? size : this.page.maxResult);
      if (this.dates && this.dates.length > 0) {
        this.page.startTime = this.dates[0];
        this.page.endTime = this.dates[1];
      } else {
        this.page.startTime = "";
        this.page.endTime = "";
      }
      this.loading = true;
      this.$http.post("/bankStatement/statementList", this.page).then(res => {
        this.loading = false;
        if (res && res.data.code == "1") {
          this.tableData = res.data.data.list;
          this.page.totall = parseInt(res.data.data.totalCount);
        }
      });
    },
    //返回到银行流水
    gobackBankList() {
      const _ = this;
      _.flag = true;
      _.bank = _.banklist[0];
      _.slectbanknumber(_.banklist[0]);
    },
    getAllPremissionMenu() {
      const _ = this;
      _.dictList.downList.splice(0);
      _.dictList.otheroBtn.splice(0);

      _.$http
        .post("sys/menu/findPermissionMenu", {
          permissions:
            "ac:bank:getReceipt,ac:bank:downReceiptPDF,ac:bank:printReceiptPDF"
        })
        .then(res => {
          if (res && res.data.code == 1) {
            _.dictList.downList = res.data.data;
          }
        });
      _.$http
        .post("sys/menu/findPermissionMenu", {
          permissions:
            "ac:bank:exportStatement,ac:bank:contract,ac:bank:breakContract"
        })
        .then(res => {
          if (res && res.data.code == 1) {
            _.dictList.otheroBtn = res.data.data;
          }
        });
    },
    pageSizeChange(val) {
      //每页数量变化事件
      this.page.maxResult = val;
      let pages = this.page.currentPage;
      this.init(pages, val);
    },
    pageIndexChange(val) {
      //页码数量变化事件
      this.page.currentPage = val;
      let size = this.page.maxResult;
      this.init(val, size);
    }
  }
  // watch: {
  //   　　"$route": {
  // 　　　　handler(newValue, oldValue) {

  // 　　　　},
  // 　　　　deep: true,
  //        immediate: true
  //   　　},

  //     }
};
</script>

<style lang="less" scoped>
.public-content.bgcs {
  background-color: #eee;
}
.btn_bannks {
  width: 130px;
  height: 32px;
  border: solid 1px #fff;
  color: #fff;
  display: flex;
  align-items: center;
  line-height: 32px;
  justify-content: center;
  font-size: 16px;
  margin-right: 30px;
  cursor: pointer;
  &.tips {
    background-color: #269d7b;
    border-color: #269d7b;
    &:hover {
      background-color: #27bd92;
    }
  }
  &.gray {
    border: dashed 1px #269d7b;
    background: none;
    color: #269d7b;
  }
}
.banner_bank {
  width: 100%;
  height: 545px;
  background: url("/static/img/bank_banner.png") no-repeat center;
  position: relative;

  .banner_bank_container {
    text-align: center;
    img {
      width: 430px;
      margin-top: 150px;
    }
    .text_s {
      display: block;
      color: #fff;
      width: 430px;
      margin: 20px auto 30px;
    }
  }
  .btn_position {
    text-align: center;
    div {
      display: inline-block;
    }
    &.bot {
      bottom: -50px;
      left: 535px;
    }
  }
}
.banner_footer {
  height: 226px;
  width: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  .banner_footer_right {
    width: calc(100% - 330px);
    height: 100%;
    background: url("/static/img/bottom_p.png") no-repeat center;
    background-size: 100% 100%;
  }
  .banner_footer_left {
    width: 300px;
    height: 100%;
    background: #fff;
    position: relative;
    .load {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .buttonGroup {
      position: absolute;
      left: 97px;
      top: 45px;
      span {
        display: inline-block;
        padding: 6px 20px;
        color: #269d7b;
        font-weight: 600;
        border: 1px dashed #32a282;
        margin-bottom: 30px;
      }
    }
    .people {
      position: absolute;
      bottom: 20px;
      left: 20px;
    }
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.nohasWater {
  width: 100%;
  .wrap {
    width: 1000px;
    display: flex;
    justify-content: space-between;
    padding-top: 100px;
    padding-bottom: 120px;
    .com {
      width: 400px;
      height: 300px;
      border: 1px dashed #d9d9d9;
      box-sizing: border-box;
      padding: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .left {
    }
    .right {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashier/account_opening.vue